import type { BlogPost } from '../types/index';

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug: 'book-reviews',
    title: 'book reviews',
    date: '2025-02-15',
    excerpt:
      'a new series where i review what i read.',
  },
];
